<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card>
          <v-card-title>
            <v-row>
              <v-col>
                <v-btn @click="showGiftcardTable = true" :color="showGiftcardTable ? 'primary' : ''">
                  Top Giftcard Traders
                </v-btn>
                <v-btn @click="showGiftcardTable = false" :color="!showGiftcardTable ? 'primary' : ''">
                  Top Crypto Traders
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>

          <v-card-title>
            <v-row align="end">
              <v-col>
                <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
                  hide-details></v-text-field>
              </v-col>
              <v-spacer></v-spacer>
              <v-menu v-model="menu" style="box-shadow: none" :close-on-content-click="false" :close-on-click="false"
                :nudge-width="100" min-width="300" max-width="300" class="menu dt-border" offset-y left>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="primary" outlined rounded dark v-bind="attrs" v-on="on">
                    <v-icon> mdi-filter-variant </v-icon>
                    filter
                  </v-btn>
                </template>
                <v-card class="pa-5" flat>
                  <label for="">Date</label>
                  <br />
                  <DateRangePicker v-model="dateRange" />
                  <v-card-actions>
                    <v-btn rounded depressed @click="reset">Reset</v-btn>
                    <v-btn color="primary" @click="applyFilter()" rounded depressed>Save</v-btn>
                  </v-card-actions>
                </v-card>
              </v-menu>
              <v-btn color="primary" class="mx-4" @click="downloadCSV">Download CSV</v-btn>
            </v-row>
            </v-card-title>


          <v-data-table v-if="showGiftcardTable" :headers="headers" :items="topTradersUsers" :search="search"
            :footer-props="{
              showFirstLastPage: true,
              firstIcon: 'mdi-arrow-collapse-left',
              lastIcon: 'mdi-arrow-collapse-right',
              prevIcon: 'mdi-minus',
              nextIcon: 'mdi-plus'
            }">
            <template v-slot:item.serial_number="{ item }">
              <v-chip :color="Number(item.serial_number) <= 10 ? 'yellow lighten-2' : ''" text-color="black">
                {{ item.serial_number }}
              </v-chip>
            </template>
            <template v-slot:item.profilepicture="{ item }">
              <v-avatar size="32" color="grey">
                <img :src="item.profilepicture" />
              </v-avatar>
            </template>
            <template v-slot:item.amount="{ item }">
              <div>{{ formatMoney(item.amount) }}</div>
            </template>
          </v-data-table>
          <v-data-table v-if="!showGiftcardTable" :headers="cryptoHeaders" :items="cryptoTraders" :search="search"
            :footer-props="{
              showFirstLastPage: true,
              firstIcon: 'mdi-arrow-collapse-left',
              lastIcon: 'mdi-arrow-collapse-right',
              prevIcon: 'mdi-minus',
              nextIcon: 'mdi-plus'
            }">
            <template v-slot:item.serial_number="{ item }">
              <v-chip :color="Number(item.serial_number) <= 10 ? 'blue lighten-4' : ''" text-color="black">
                {{ item.serial_number }}
              </v-chip>
            </template>

            <template v-slot:item.profilepicture="{ item }">
              <v-avatar size="32" color="grey">
                <img :src="item.profilepicture" />
              </v-avatar>
            </template>
            <template v-slot:item.amount="{ item }">
              <div>{{ formatMoney(item.amount) }}</div>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import DateRangePicker from "@/components/DateRangePicker.vue";

// =========== IMPORT SERVICE =========
import { PromoService } from "@/services";
import { formatMoney } from '@/utils/moneyFormatter';

export default {
  data: () => ({
    giftFilter: 'all time',

    showGiftcardTable: true,
    topTradersUsers: [],
    cryptoTraders: [],
    search: "",
    headers: [
      { text: "S/N", value: "serial_number", width: "50px" },
      { text: "Profile Picture", value: "profilepicture" },
      // { text: "First Name", value: "firstname" },
      // { text: "Last Name", value: "lastname" },
      { text: "Username", value: "username" },

      // { text: "email", value: "email" },
      { text: "Points", value: "total_loader_amount" },
      { text: "Amount ($)", value: "amount" },
    ],

    cryptoHeaders: [
      { text: "S/N", value: "serial_number", width: "50px" },
      { text: "Profile Picture", value: "profilepicture" },
      // { text: "First Name", value: "firstname" },
      // { text: "Last Name", value: "lastname" },
      { text: "Username", value: "username" },

      { text: "email", value: "email" },
      { text: "Points", value: "total_loader_amount" },

      { text: "Amount ($)", value: "amount" },
    ],
    menu: false,
    dateRange: {
      startDate: null,
      endDate: null,
    },
  }),
  async mounted() {
    this.getTopTraders();
    this.loadCryptoTraders()
  },
  methods: {
    async getTopTraders() {
      try {
        this.topTradersUsers = [];
        this.loading = true;
        let data = await PromoService.getGiftcardTraders(this.dateRange);
        this.loading = false;
        this.topTradersUsers = data;
      } catch (error) {
        this.loading = false;
      }
    },

    applyFilter() {
      this.getTopTraders()
      this.loadCryptoTraders()
      this.menu = false;
    },

    async loadCryptoTraders() {
      try {
        this.cryptoTraders = [];
        this.loading = true;
        let data = await PromoService.getCryptoTraders(this.dateRange);
        this.loading = false;
        this.cryptoTraders = data;
      } catch (error) {
        this.loading = false;
      }
    },
    formatMoney(amount) {
      return formatMoney(amount, false);
    },
    convertToCSV(objArray) {
      const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
      let str = '';

      // Add header row with field names
      let headerRow = '';
      for (let key in array[0]) {
        if (headerRow !== '') headerRow += ',';
        headerRow += key;
      }
      str += headerRow + '\r\n';

      // Add data rows
      for (let i = 0; i < array.length; i++) {
        let line = '';
        for (let key in array[i]) {
          if (line !== '') line += ',';
          line += array[i][key];
        }
        str += line + '\r\n';
      }

      return str;
    },
    downloadCSV() {
      let data = this.showGiftcardTable ? this.topTradersUsers : this.cryptoTraders;
      const csvString = this.convertToCSV(data); // this.data is the object you want to download
      const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.setAttribute('href', url);
      link.setAttribute('download', `top_${this.showGiftcardTable ? 'giftcard' : 'crypto'}_traders.csv`);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    reset() {
      this.dateRange = {
        startDate: null,
        endDate: null,
      };
      this.applyFilter()
      this.menu = false;
    }
  },
  components: {
    DateRangePicker,
  },
  watch: {
    showGiftcardTable() {
      this.search = '';
    }
  }
};
</script>
